export const
    CUSTOM_FIELD_RESET = 'custom_field_reset',
    CUSTOM_FIELDS_RESET = 'custom_fields_reset',
    CUSTOM_FIELDS_PENDING = 'custom_fields_pending',
    CUSTOM_FIELD_FOCUS = 'custom_field_focus',
    CUSTOM_FIELD_DELETED = 'custom_field_deleted',
    CUSTOM_FIELD_POSTING = 'custom_field_posting',
    CUSTOM_FIELD_EDITING = 'custom_field_editing',
    CUSTOM_FIELD_DELETING = 'custom_field_deleting',
    CUSTOM_FIELD_FAILED = 'custom_field_failed',
    CUSTOM_FIELDS_FAILED = 'custom_fields_failed',
    CUSTOM_FIELD_DOWNLOADED = 'custom_field_downloaded',
    CUSTOM_FIELDS_DOWNLOADED = 'custom_fields_downloaded';



// WEBPACK FOOTER //
// src/store/customfields/types.js